import * as React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Box,
    Stack,
    FormControlLabel,
    Checkbox,
    Chip
} from '@mui/material';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';

export const MIGRATION_NOTICE_SUPPRESS_KEY = 'app_migration_notice_suppress_until';
const SUPPRESS_DAYS = 7;

export const getMigrationNoticeShouldShow = () => {
    const raw = window.localStorage.getItem(MIGRATION_NOTICE_SUPPRESS_KEY);
    if (!raw) {
        return true;
    }

    const suppressUntil = Number(raw);
    if (!Number.isFinite(suppressUntil)) {
        window.localStorage.removeItem(MIGRATION_NOTICE_SUPPRESS_KEY);
        return true;
    }

    return Date.now() >= suppressUntil;
};

export const setMigrationNoticeSuppressDays = (days = SUPPRESS_DAYS) => {
    const suppressUntil = Date.now() + days * 24 * 60 * 60 * 1000;
    window.localStorage.setItem(MIGRATION_NOTICE_SUPPRESS_KEY, String(suppressUntil));
};

export const AppMigrationNoticeDialog = ({ open, onClose }) => {
    const [noRemind7Days, setNoRemind7Days] = React.useState(false);

    React.useEffect(() => {
        if (!open) {
            setNoRemind7Days(false);
        }
    }, [open]);

    const handleClose = () => {
        if (noRemind7Days) {
            setMigrationNoticeSuppressDays(7);
        }
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="sm"
            PaperProps={{
                sx: {
                    borderRadius: '16px',
                    overflow: 'hidden'
                }
            }}
        >
            <DialogTitle
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    py: 2,
                    borderBottom: '1px solid',
                    borderColor: 'divider'
                }}
            >
                <CampaignOutlinedIcon color="primary" />
                <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 700 }}>
                    功能迁移通知
                </Typography>
                <Chip size="small" label="重要" color="primary" variant="outlined" sx={{ ml: 'auto' }} />
            </DialogTitle>

            <DialogContent sx={{ px: 3, pt: 3, pb: 1.5 }}>
                <Stack spacing={2.25}>
                    <Box>
                        <Typography
                            sx={{
                                fontSize: '1.125rem',
                                fontWeight: 700,
                                color: 'text.primary',
                                lineHeight: 1.6
                            }}
                        >
                            在线切片功能已下线
                        </Typography>
                        <Typography
                            sx={{
                                mt: 0.75,
                                color: 'text.secondary',
                                lineHeight: 1.85
                            }}
                        >
                            APP 版本即将上线，切片能力将迁移至 APP 提供。
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            p: 1.75,
                            borderRadius: '10px',
                            bgcolor: 'rgba(255, 139, 147, 0.08)',
                            border: '1px solid',
                            borderColor: 'rgba(255, 139, 147, 0.2)'
                        }}
                    >
                        <Typography sx={{ fontSize: '0.9375rem', color: 'text.secondary', lineHeight: 1.75 }}>
                            网页端字幕搜索、字幕详情与 AI 总结等功能可继续正常使用。
                        </Typography>
                    </Box>

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={noRemind7Days}
                                onChange={(event) => setNoRemind7Days(event.target.checked)}
                            />
                        }
                        label="7天内不再提醒"
                    />
                </Stack>
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2.25 }}>
                <Button onClick={handleClose} variant="contained" sx={{ borderRadius: '8px', textTransform: 'none' }}>
                    我知道了
                </Button>
            </DialogActions>
        </Dialog>
    );
};
